var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Generate password')},model:{value:(_vm.generate_password),callback:function ($$v) {_vm.generate_password=$$v},expression:"generate_password"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }